import { AbilityBuilder } from "@casl/ability";
import { AppAbility } from "modules/auth";

export const defineRulesForFarmer = (abilityBuilder: AbilityBuilder<AppAbility>) => {
    const { can, cannot, rules } = abilityBuilder;

    cannot("view", "UserActivityModule");
    cannot("view", "UserAdministrationModule");
    cannot("view", "ModulesAdministrationModule");
    cannot("view", "CommunicationModule");
    can("view", "UserNotificationsModule");

    can("view", "InternalSystemsModule");
    can("view", "ExternalModules");
    can("view", "AdditionalModules");
    cannot("view", "EducationAnalysis");
    cannot("view", "SemisAdministrationModule");
    cannot("view", "SEMIS");
    cannot("view", "InternalDocumentation");
    cannot("view", "PIO");
    cannot("view", "Webtop");
    cannot("view", "ReportProblem");

    can("view", "Records");
    cannot("update", "Records");

    can("view", "EducationModule");
    can("view", "EducationLinks");
    cannot("view", "EducationDocuments");
    cannot("update", "EducationDocuments");

    cannot("view", "CourseList");
    cannot("view", "FarmList");
    cannot("update", "UserRole");

    can("view", "CourseRegistration");
    can("view", "AgroclimateStations");

    can("view", "WeatherAlarmToggle");

    cannot("view", "Beekeeping");
    cannot("update", "Beekeeping");

    return rules;
};
